import React, { useState } from "react";

import Button from "components/Button";
import clsx from "clsx";

const Question = ({onAskQuestion}) => {
  const [query, setQuery] = useState("");
  const askQuestion = () => {
    onAskQuestion({'query': query});
  }
  return (
  <div>
    <div className="field">
      <div className="control">
        <textarea className="textarea" placeholder="Ecrivez votre question ici" rows="3" value={query} onChange={(e) => setQuery(e.currentTarget.value)}>
        </textarea>
      </div>
    </div>
    <Button onClick={askQuestion} className="is-primary mb-4">
      Envoyer
    </Button>
  </div>
  )
}

const AskQuestion = ({onAskQuestion}) => {
  const [askQuestion, setAskQuestion] = useState(false);
  const onSend = (data) => {
    onAskQuestion(data);
    setAskQuestion(false);
  }
  return (
    <div className="has-text-centered">
      {askQuestion &&
        <Question onAskQuestion={onSend} />
      }
      <Button className={clsx("is-text")} onClick={() => setAskQuestion(!askQuestion)}>
        {!askQuestion ?
          "Poser une question"
        :
          "Ne pas poser la question"
        }
      </Button>
    </div>
  )
}

export default AskQuestion;